import { getAccountUserName, getAccountUserSteamId } from "./user";

export const ACCOUNT_EXTERNAL_URLS = {
  DONATE_BASE: "https://donatello.to/stalkers-reborn",
  STEAM_PROFILE: "https://steamcommunity.com/profiles/",
  STEAM_ID: "https://steamid.io/lookup/",
};

export const buildAccountDonateUrl = (
  user,
  baseUrl = ACCOUNT_EXTERNAL_URLS.DONATE_BASE,
) => {
  if (!user || typeof user !== "object") {
    return baseUrl;
  }

  const username = getAccountUserName(user);
  const steamId = getAccountUserSteamId(user);
  const params = new URLSearchParams();

  if (username && username !== "Player" && username !== "Guest") {
    params.set("c", username);
  }

  if (steamId) {
    params.set("m", steamId);
  }

  const query = params.toString();

  return query ? `${baseUrl}?${query}` : baseUrl;
};

export const buildAccountSteamProfileUrl = (
  steamId,
  baseUrl = ACCOUNT_EXTERNAL_URLS.STEAM_PROFILE,
) => (steamId ? `${baseUrl}${steamId}` : baseUrl);

export const buildAccountSteamIdLookupUrl = (
  steamId,
  baseUrl = ACCOUNT_EXTERNAL_URLS.STEAM_ID,
) => (steamId ? `${baseUrl}${steamId}` : baseUrl);
